<template>

    <div class="mainDivNofiles" 
         style="padding: 0px; margin: 0px;">

        <form @submit.prevent="onSubmit" 
              id="formFileUploadID" 
              style="padding: 0px; margin: 0px;"
              enctype="multipart/form-data">

            <div class="itemCenterCenter" style="text-align: left; padding: 0px; margin: 0px;">
                <label class="material-icons forIconNewRecord text-success" 
                       for="inputCtrlUploadId"
                       style=" padding: 0px; margin: 0px;">
                    add_card 
                    <input id="inputCtrlUploadId" 
                        style="display: none" 
                        accept=".png, .pdf, .xls, .xlsx, .jpg"
                        @change="handleFileSelection" 
                        type="file" />
                </label>
            </div>

        </form>

    </div>

</template>
  
<script>

export default {
    data() {
        return {

            enableFunctionTracing: false,
            enableDataLogging: false,

            //This is the list of file objects uploaded using the multi-part upload
            //control. At each step in processing, this list will always contain all
            //files currently selected for uploading. This is file form data.
            uploadFileList: null,

            //This is an array of json objects which each have two properties. Those
            //properties are file name and file size. This is the array which is displayed
            //in the HTML to show the user the file names and file sizes.
            //This data is displayed for selected files which are intended to be uploaded.
            //This is not the data displayed for file returned by the server.
            fileDisplayArray: null,
        };
    },
    created() {
        if (this.$data.enableFunctionTracing) {
            console.log("UploadAgentSimplified(): **** created ****");
        }
    },

    emits: ['proccessFiles'],

    props: {},
    watch: {},
    methods: {

        // ------------------------------------------------------
        // ---------------- Emit Events -------------------------
        // ------------------------------------------------------

        emitFiles() {
            if (this.$data.enableFunctionTracing) {
                console.log("**** UploadAgent: emitFiles ****");
            }
            if (this.$data.enableDataLogging) {
                this.log_uploadFileList();
            }

            this.$emit('proccessFiles', this.$data.uploadFileList);
        },

        //-------------------------------------------------------------------
        //------------- Event Handlers --------------------------------------
        //-------------------------------------------------------------------

        handleFileSelection() {
            if (this.$data.enableFunctionTracing) {
                console.log("**** UploadAgent: handleFileSelection ****");
            }

            let fileUploadCtrl = document.getElementById("inputCtrlUploadId");
            this.$data.uploadFileList = new FormData();

            for (let fileItem of fileUploadCtrl.files) {
                this.$data.uploadFileList.append("files", fileItem);
            }

            if (this.$data.enableDataLogging) {
                console.log("----->  UploadAgent:  #aaaaaaa <-------");
                this.log_fileUploadCtrl(fileUploadCtrl);
            }

            if (this.$data.enableDataLogging) {
                console.log("----->  UploadAgent:  #bbbbbbb <--------");
                this.log_uploadFileList();
            }

            // console.log('========== upload agent ============');
            // this.$data.uploadFileList.forEach((element) => {
            //     console.log('element = ', element);
            // });
            // console.log('========== upload agent ============');

            this.emitFiles();
        },

        //-------------------------------------------------------------------
        //------------- Logging Functions -----------------------------------
        //-------------------------------------------------------------------

        log_uploadFileList() {
            if (this.$data.enableDataLogging) {
                console.log('-------- UploadAgent: log_uploadFileList() START --------------');
                console.log('sssssssssssssssssssssssssssssssssssssssssssssssssssss');

                this.$data.uploadFileList.forEach((element) => {
                    console.log('-------- log_uploadFileList ----------');
                    console.log("uploadFileList: element = ", element);
                    console.log("uploadFileList: element.name = ", element.name);
                    console.log("uploadFileList: element.size = ", element.size);
                    console.log("uploadFileList: element.type = ", element.type);
                    console.log("uploadFileList: element.lastModifiedDate = ", element.lastModifiedDate);
                });
                console.log('-------- UploadAgent: log_uploadFileList() END --------------');
                console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
            }
        },

        log_fileUploadCtrl(ctrl) {
            if (this.$data.enableDataLogging) {
                console.log('--------  UploadAgent:  log_fileUploadCtrl() START --------------');
                console.log('sssssssssssssssssssssssssssssssssssssssssssssssssssss');
                console.log('ctrl = ', ctrl);
                for (let fileItem of ctrl.files) {
                    console.log("------ log_fileUploadCtrl ---------");
                    console.log("fileUploadCtrl: fileItem = ", fileItem);
                    console.log("fileUploadCtrl: fileItem.name = ", fileItem.name);
                }
                console.log('-------- log_fileUploadCtrl() END --------------');
                console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee');
            }
        },
    },
};
</script>

<style scoped>
/* ---------- containers -------------------- */
.forIconNewRecord {
  margin-left: 5px;
  cursor: pointer;
  font-size: 24px;
  vertical-align: middle;
}

.itemCenterCenter {
  display: flex;
  align-items: center;
  justify-content: start;
}

.mainDivNofiles {
    align-items: left;
    display: flex;
}

</style>

  